import moment from "moment";
import ProductionView from "./ProductionView";

const ProductionsView2025 = ({ productions, showProductionDates }) => {
  return (
    <div>
      <h4>Inventory, Purchase and Manufacturing</h4>

      <div className="space-y-4 mt-4 -mx-2">
        {productions.length > 0 ? (
          <table>
            <thead>
              <tr className="whitespace-nowrap">
                <th className="py-3 text-left">Production</th>
                <th className="py-3 text-right">Request QTY</th>
                <th className="py-3 text-right">Using Stock(Forecasted)</th>
                <th className="py-3 text-right">To Consumed</th>
                <th className="py-3 text-right">To Produce</th>
              </tr>
            </thead>
            <tbody>
              {productions.map((production, index) => (
                <ProductionView
                  key={index}
                  index={index}
                  production={production}
                  prevProductions={productions
                    .filter((i) => production.prev_productions.includes(i.id))
                    .sort(
                      (a, b) => moment(a.ready_date) - moment(b.ready_date),
                    )}
                  showProductionDates={showProductionDates}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <div className="px-2">
            No stock or production are considered for this plan.
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductionsView2025;
